import dayjs from "dayjs"

const DATE_FORMAT = "YYYY-MM-DD"

// check DayjsProvider
const getNow = () => dayjs.tz()

export { DATE_FORMAT, getNow }
